export default "__VITE_ASSET__Ce1E0JDa__"